/*
 * Winkelwagen-lade — vervangt UpCart.
 * - Neemt "toevoegen aan winkelwagen" van het theme over (theme:cart:add)
 * - Rendert de lade server-side via de Section Rendering API (sections/custom-cart.liquid)
 * - Voegt het gratis cadeau toe/verwijdert het op basis van de meetellende artikelen
 *   (die telling gebeurt in Liquid, zodat alleen de juiste collecties meetellen)
 * - Toont aanbevolen producten via Shopify's productaanbevelingen
 */
(function () {
  'use strict';

  if (window.__customCart) return;
  window.__customCart = true;

  var SECTION = 'custom-cart';
  var UPSELL_SECTION = 'custom-cart-upsell';
  var OWN_HEADER = 'X-Custom-Cart';
  var nativeFetch = window.fetch.bind(window);
  var queue = Promise.resolve();
  var lastFocus = null;
  var upsellCache = {};

  function root() {
    return document.querySelector('[data-cv-cart]');
  }

  function base() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function cfg() {
    var r = root();
    return {
      gift: Number(r && r.getAttribute('data-gift-variant')) || 0,
      threshold: Number(r && r.getAttribute('data-gift-threshold')) || 0,
      invalid: (r && r.getAttribute('data-discount-invalid')) || '',
      upsellLimit: Number(r && r.getAttribute('data-upsell-limit')) || 8
    };
  }

  function enqueue(task) {
    queue = queue.then(task).catch(function (error) {
      console.error('[Cart]', error);
    });
    return queue;
  }

  function request(url, options) {
    options = options || {};
    var headers = Object.assign({ Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, options.headers || {});
    headers[OWN_HEADER] = '1';
    if (options.json !== undefined) {
      headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(options.json);
    }
    return nativeFetch(url, { method: options.method || 'GET', headers: headers, body: options.body, credentials: 'same-origin' })
      .then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          if (!response.ok) {
            var error = new Error(data.description || data.message || 'Er ging iets mis');
            error.data = data;
            throw error;
          }
          return data;
        });
      });
  }

  function getCart() {
    return request('/cart.js');
  }

  /* Let op: '/cart' + Accept: application/json geeft cart.js terug i.p.v. de sectie,
     daarom renderen via de root-URL. */
  function fetchSection() {
    return request(base() + '?sections=' + SECTION).then(function (sections) {
      var html = sections && sections[SECTION];
      if (!html) return null;
      return new DOMParser().parseFromString(html, 'text/html');
    });
  }

  /* ---------- Open / sluiten ---------- */

  function open() {
    var r = root();
    if (!r) return false;
    if (!r.classList.contains('is-open')) lastFocus = document.activeElement;
    r.classList.add('is-open');
    r.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cv-cart-open');
    var panel = r.querySelector('.cv-cart__panel');
    if (panel) panel.focus({ preventScroll: true });
    loadUpsell();
    return true;
  }

  function close() {
    var r = root();
    if (!r) return;
    r.classList.remove('is-open');
    r.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cv-cart-open');
    if (lastFocus && typeof lastFocus.focus === 'function') {
      try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  function setLoading(on) {
    var r = root();
    if (r) r.classList.toggle('is-loading', !!on);
  }

  /* ---------- Renderen ---------- */

  function render(doc) {
    var r = root();
    if (!doc || !r) return;
    var freshRoot = doc.querySelector('[data-cv-cart]');
    var fresh = doc.querySelector('[data-cv-content]');
    var current = r.querySelector('[data-cv-content]');
    if (!fresh || !current) return;

    var body = current.querySelector('.cv-cart__body');
    var scroll = body ? body.scrollTop : 0;

    current.replaceWith(document.importNode(fresh, true));

    if (freshRoot) {
      ['data-gift-variant', 'data-gift-threshold', 'data-discount-invalid', 'data-upsell-limit'].forEach(function (attr) {
        if (freshRoot.hasAttribute(attr)) r.setAttribute(attr, freshRoot.getAttribute(attr));
      });
    }

    var newBody = r.querySelector('.cv-cart__body');
    if (newBody) newBody.scrollTop = scroll;
    loadUpsell();
  }

  function sectionCount(doc) {
    var el = doc && doc.querySelector('[data-cv-count]');
    return el ? Number(el.textContent) || 0 : 0;
  }

  function updateCount(count) {
    document.querySelectorAll('cart-count[data-cart-count], [data-cv-count]').forEach(function (el) {
      el.textContent = count;
      if (el.hasAttribute('data-cart-count')) el.setAttribute('data-cart-count', count);
    });
  }

  /* ---------- Cadeau ---------- */

  function syncGift(doc) {
    var c = cfg();
    var content = doc && doc.querySelector('[data-cv-content]');
    if (!content || !c.gift || !c.threshold) return Promise.resolve(false);

    var qualifying = Number(content.getAttribute('data-qualifying')) || 0;
    var giftKeys = (content.getAttribute('data-gift-keys') || '').split(',').filter(Boolean);

    if (qualifying >= c.threshold) {
      if (!giftKeys.length) {
        return request('/cart/add.js', {
          method: 'POST',
          json: { items: [{ id: c.gift, quantity: 1, properties: { _cv_gift: '1' } }] }
        }).then(function () { return true; }).catch(function () { return false; });
      }
      if (giftKeys.length > 1) {
        return giftKeys.slice(1).reduce(function (p, key) {
          return p.then(function () {
            return request('/cart/change.js', { method: 'POST', json: { id: key, quantity: 0 } });
          });
        }, Promise.resolve()).then(function () { return true; });
      }
      return Promise.resolve(false);
    }

    if (giftKeys.length) {
      return giftKeys.reduce(function (p, key) {
        return p.then(function () {
          return request('/cart/change.js', { method: 'POST', json: { id: key, quantity: 0 } });
        });
      }, Promise.resolve()).then(function () { return true; });
    }

    return Promise.resolve(false);
  }

  function refresh() {
    setLoading(true);
    return fetchSection()
      .then(function (doc) {
        return syncGift(doc).then(function (changed) {
          return changed ? fetchSection() : doc;
        });
      })
      .then(function (doc) {
        render(doc);
        var count = sectionCount(doc);
        updateCount(count);
        document.dispatchEvent(new CustomEvent('custom-cart:updated', { detail: { count: count } }));
        return doc;
      })
      .finally(function () { setLoading(false); });
  }

  /* ---------- Aanbevolen producten ---------- */

  function loadUpsell() {
    var r = root();
    var box = r && r.querySelector('[data-cv-upsell]');
    var content = r && r.querySelector('[data-cv-content]');
    if (!box || !content) return;
    var productId = content.getAttribute('data-first-product');
    if (!productId) return;
    var inCart = (content.getAttribute('data-cart-products') || '').split(',');

    var cached = upsellCache[productId];
    var promise = cached || nativeFetch(base() + 'recommendations/products?section_id=' + UPSELL_SECTION +
      '&product_id=' + encodeURIComponent(productId) + '&limit=' + cfg().upsellLimit + '&intent=related', {
      credentials: 'same-origin'
    }).then(function (res) { return res.ok ? res.text() : ''; }).catch(function () { return ''; });
    upsellCache[productId] = promise;

    promise.then(function (html) {
      if (!html || !box.isConnected) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var cards = Array.prototype.slice.call(doc.querySelectorAll('[data-cv-upsell-product]')).filter(function (card) {
        return inCart.indexOf(card.getAttribute('data-cv-upsell-product')) === -1;
      });
      if (!cards.length) return;
      var track = box.querySelector('[data-cv-upsell-track]');
      track.innerHTML = '';
      cards.forEach(function (card) { track.appendChild(document.importNode(card, true)); });
      box.hidden = false;
    });
  }

  function addUpsell(button) {
    var card = button.closest('[data-cv-upsell-product]');
    var field = card && card.querySelector('[data-cv-upsell-variant]');
    var id = field && Number(field.value);
    if (!id) return Promise.resolve();
    button.setAttribute('data-cv-loading', '');
    setLoading(true);
    return request('/cart/add.js', { method: 'POST', json: { items: [{ id: id, quantity: 1 }] } })
      .then(refresh)
      .catch(function (error) {
        setLoading(false);
        showDrawerError(error.message);
      })
      .finally(function () { button.removeAttribute('data-cv-loading'); });
  }

  /* ---------- Toevoegen (overname van het theme) ---------- */

  function showFormError(form, message) {
    var box = form && (form.querySelector('[data-cart-errors-container]') ||
      (form.closest('.product__content, .product-quick-add, [data-section-type]') || document).querySelector('[data-cart-errors-container]'));
    if (box) {
      box.textContent = message;
      box.style.display = 'block';
      setTimeout(function () { box.textContent = ''; box.style.display = ''; }, 5000);
    } else {
      window.alert(message);
    }
  }

  function closeQuickAdd(button) {
    var modal = button && button.closest('dialog, .product-modal, [data-quick-add-modal]');
    if (!modal) return;
    var closer = modal.querySelector('[data-quick-add-modal-close], [data-popup-close], .product-modal__close, .drawer__close');
    if (closer) closer.click();
  }

  function addFromButton(button) {
    var form = button && (button.form || button.closest('form'));
    if (!form) return Promise.resolve();
    if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
      form.reportValidity();
      return Promise.resolve();
    }

    var formData = new FormData(form);
    if (!formData.get('id')) {
      showFormError(form, 'Kies eerst een maat en kleur.');
      return Promise.resolve();
    }

    button.setAttribute('data-cv-loading', '');
    return request('/cart/add.js', { method: 'POST', body: formData })
      .then(function () {
        closeQuickAdd(button);
        return refresh().then(open);
      })
      .catch(function (error) {
        showFormError(form, error.message);
      })
      .finally(function () {
        button.removeAttribute('data-cv-loading');
      });
  }

  window.addEventListener('theme:cart:add', function (event) {
    var button = event.detail && event.detail.button;
    if (!button || !root()) return;
    event.stopImmediatePropagation();
    event.preventDefault();
    if (button.hasAttribute('disabled')) return;
    enqueue(function () { return addFromButton(button); });
  }, true);

  window.addEventListener('theme:cart:toggle', function (event) {
    if (!root()) return;
    event.stopImmediatePropagation();
    open();
  }, true);

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-cart-toggle], a[href="/cart"], a[href$="/cart"]');
    if (!toggle || toggle.closest('[data-cv-cart]') || !root()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    open();
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]') || !root()) return;
    if (form.querySelector('input[type="file"]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var button = event.submitter || form.querySelector('[type="submit"], [data-add-to-cart]') || form;
    enqueue(function () { return addFromButton(button); });
  }, true);

  /* ---------- Acties in de lade ---------- */

  function lineKey(el) {
    var line = el.closest('[data-cv-key]');
    return line && line.getAttribute('data-cv-key');
  }

  function changeLine(key, quantity) {
    if (!key) return Promise.resolve();
    setLoading(true);
    return request('/cart/change.js', { method: 'POST', json: { id: key, quantity: Math.max(0, quantity) } })
      .then(refresh)
      .catch(function (error) {
        setLoading(false);
        showDrawerError(error.message);
      });
  }

  function showDrawerError(message) {
    var box = document.querySelector('[data-cv-discount-error]');
    if (!box) return;
    box.textContent = message;
    box.hidden = false;
  }

  function currentCodes(cart) {
    return (cart.discount_codes || []).map(function (d) { return d.code; });
  }

  function applyDiscount(code) {
    code = (code || '').trim();
    if (!code) return Promise.resolve();
    setLoading(true);
    return getCart().then(function (cart) {
      var codes = currentCodes(cart).filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); });
      codes.push(code);
      return request('/cart/update.js', { method: 'POST', json: { discount: codes.join(',') } });
    }).then(function (cart) {
      var applied = (cart.discount_codes || []).find(function (d) { return d.code.toLowerCase() === code.toLowerCase(); });
      if (!applied || !applied.applicable) {
        var keep = (cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
        return request('/cart/update.js', { method: 'POST', json: { discount: keep.join(',') } })
          .then(refresh)
          .then(function () { showDrawerError(cfg().invalid); });
      }
      return refresh();
    }).catch(function (error) {
      setLoading(false);
      showDrawerError(error.message);
    });
  }

  function removeDiscount(code) {
    setLoading(true);
    return getCart().then(function (cart) {
      var codes = currentCodes(cart).filter(function (c) { return c !== code; });
      return request('/cart/update.js', { method: 'POST', json: { discount: codes.join(',') } });
    }).then(refresh).catch(function (error) {
      setLoading(false);
      showDrawerError(error.message);
    });
  }

  function goToCheckout() {
    if (typeof window.proceedToCheckout === 'function') {
      window.proceedToCheckout();
    } else {
      window.location.href = base() + 'checkout';
    }
  }

  function scrollUpsell(dir) {
    var track = root() && root().querySelector('[data-cv-upsell-track]');
    if (track) track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
  }

  document.addEventListener('click', function (event) {
    var r = root();
    if (!r || !r.contains(event.target)) return;

    if (event.target.closest('[data-cv-close]')) {
      event.preventDefault();
      close();
      return;
    }

    var remove = event.target.closest('[data-cv-remove]');
    if (remove) {
      event.preventDefault();
      var key = lineKey(remove);
      enqueue(function () { return changeLine(key, 0); });
      return;
    }

    var qtyBtn = event.target.closest('[data-cv-qty]');
    if (qtyBtn) {
      event.preventDefault();
      var qtyKey = lineKey(qtyBtn);
      var qty = Number(qtyBtn.getAttribute('data-cv-qty'));
      enqueue(function () { return changeLine(qtyKey, qty); });
      return;
    }

    var removeCode = event.target.closest('[data-cv-remove-code]');
    if (removeCode) {
      event.preventDefault();
      var code = removeCode.getAttribute('data-cv-remove-code');
      enqueue(function () { return removeDiscount(code); });
      return;
    }

    var upsellAdd = event.target.closest('[data-cv-upsell-add]');
    if (upsellAdd) {
      event.preventDefault();
      enqueue(function () { return addUpsell(upsellAdd); });
      return;
    }

    if (event.target.closest('[data-cv-upsell-prev]')) { scrollUpsell(-1); return; }
    if (event.target.closest('[data-cv-upsell-next]')) { scrollUpsell(1); return; }

    if (event.target.closest('[data-cv-pay]')) {
      event.preventDefault();
      goToCheckout();
    }
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest && event.target.closest('[data-cv-qty-input]');
    if (!input || !root() || !root().contains(input)) return;
    var key = lineKey(input);
    var qty = parseInt(input.value, 10);
    if (isNaN(qty)) return;
    enqueue(function () { return changeLine(key, qty); });
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest && event.target.closest('[data-cv-discount-form]');
    if (!form) return;
    event.preventDefault();
    var input = form.querySelector('input');
    var code = input ? input.value : '';
    enqueue(function () { return applyDiscount(code); });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      var r = root();
      if (r && r.classList.contains('is-open')) close();
    }
  });

  /* ---------- Wijzigingen door andere scripts/apps ---------- */

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var headers = (init && init.headers) || {};
    var own = headers instanceof Headers ? headers.has(OWN_HEADER) : !!headers[OWN_HEADER];
    var promise = nativeFetch(input, init);
    if (!own && /\/cart\/(add|change|clear|update)(\.js)?(\?|$)/.test(url)) {
      var isAdd = /\/cart\/add/.test(url);
      promise.then(function (response) {
        if (response.ok) enqueue(function () { return refresh().then(function () { if (isAdd) open(); }); });
      }).catch(function () {});
    }
    return promise;
  };

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) enqueue(refresh);
  });

  /* Cadeau-status ook controleren bij het laden van de pagina */
  function init() {
    var r = root();
    if (!r) return;
    var content = r.querySelector('[data-cv-content]');
    var c = cfg();
    var qualifying = Number(content && content.getAttribute('data-qualifying')) || 0;
    var giftKeys = ((content && content.getAttribute('data-gift-keys')) || '').split(',').filter(Boolean);
    var needsSync = c.threshold && ((qualifying >= c.threshold && giftKeys.length !== 1) || (qualifying < c.threshold && giftKeys.length));
    if (needsSync) enqueue(refresh);
  }

  window.CustomCart = { open: open, close: close, refresh: function () { return enqueue(refresh); } };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
